// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorials-container {
  width: 81.7% !important;
  margin-left: 18% !important;
  align-items: center;
  justify-content: space-around;
}
@media (max-width: 1024px) {
  .tutorials-container {
    width: 100% !important;
    margin-left: 0px !important;
  }
}
.tutorials-container .tutorials-inner-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 85%;
  height: 80%;
  overflow-y: auto;
}
.tutorials-container .tutorials-inner-container .video-container {
  width: 31%;
  height: 46%;
}
.tutorials-container .tutorials-inner-container .video-container .video-title {
  font-weight: 600;
  color: #003478;
}`, "",{"version":3,"sources":["webpack://./src/components/Tutorial/style.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;AACJ;AACI;EANJ;IAOO,sBAAA;IACA,2BAAA;EAEL;AACF;AAAI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EAEA,UAAA;EACA,WAAA;EACA,gBAAA;AACR;AACQ;EACI,UAAA;EACA,WAAA;AACZ;AACY;EACI,gBAAA;EACA,cAAA;AAChB","sourcesContent":[".tutorials-container {\r\n    width: 81.7% !important;\r\n    margin-left: 18% !important;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n \r\n    @media (max-width: 1024px) {\r\n       width:100% !important;\r\n       margin-left:0px !important;\r\n    }\r\n\r\n    .tutorials-inner-container{\r\n        display: flex;\r\n        flex-direction: row; \r\n        flex-wrap: wrap; \r\n        justify-content: space-between;\r\n        \r\n        width: 85%;\r\n        height: 80%;\r\n        overflow-y: auto;\r\n\r\n        .video-container{\r\n            width: 31%;\r\n            height: 46%;\r\n\r\n            .video-title{\r\n                font-weight: 600;\r\n                color:#003478;\r\n            }\r\n        }\r\n    }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
